import { makeStyles, withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

export const useStyles = makeStyles((theme) => ({
  eventContainer: {
    borderRadius: 12,
  },
  table: {
    minWidth: 950,
    [theme.breakpoints.down('sm')]: {
      width: 1500,
    },
  },
  bulletIcon: {
    width: 6,
    height: 6,
    marginRight: 5,
  },
  butlletIconAndStateRow: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  eyeIcon: {
    width: 16,
    height: 11,
    cursor:'pointer',
  },
  uploadIcon:{
    height:11,
    width:16,
    cursor:'pointer',
  },
  iconsContainerRow: {
    width: 60,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));


export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#5B6773',
    color: '#ffffff',
    height: 52,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 16,
    paddingLeft: 30
  },
  body: {
    fontSize: 14,
    height: 52,
    color: '#5B6773',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    // fontSize: 16,
    paddingLeft: 30,
  },
}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#F4F6F8',
    },
  },
}))(TableRow);